import React from 'react'

const buttonVariants = {
  default: "bg-[#203a8a] text-white hover:bg-[#1a2f6e] font-semibold font-sans",
  destructive: "bg-red-600 text-white hover:bg-red-700",
  outline: "border border-[#203a8a] text-[#203a8a] bg-transparent hover:bg-[#203a8a] hover:text-white",
  secondary: "bg-[#E8C547] text-[#203a8a] hover:bg-[#d4af3a] font-semibold font-sans",
  ghost: "hover:bg-gray-100 text-gray-700",
  link: "text-[#203a8a] underline-offset-4 hover:underline",
}

const buttonSizes = {
  default: "h-10 px-4 py-2",
  sm: "h-9 rounded-md px-3",
  lg: "h-11 rounded-md px-8",
  icon: "h-10 w-10",
}

export function Button({ 
  className = "", 
  variant = "default", 
  size = "default", 
  asChild = false, 
  disabled = false,
  ...props 
}) {
  const Comp = asChild ? "div" : "button"
  
  return (
    <Comp
      className={`inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ${buttonVariants[variant]} ${buttonSizes[size]} ${className}`}
      disabled={disabled}
      {...props}
    />
  )
}
